export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const BAR_COLORS = [
  '#4dc9f6',
  '#f67019',
  '#f53794',
  '#537bc4',
  '#acc236',
  '#166a8f',
  '#00a950',
  '#58595b',
  '#8549ba',
  '#e8c3b9',
  '#8e5ea2',
  '#b2dfdb',
];

export const DOUGHNUT_COLORS = ['#7787f9', '#a68dcf', '#d28da2'];

export const LOCAL_STORAGE_USER_KEY = 'leather-store-user';
export const LOCAL_STORAGE_CART = 'leather-store-cart';

export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000/'
    : 'https://leather-store.fly.dev/';
